import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { AuthenticationForm, TextField } from './AuthenticationForm';
import { ButtonLink } from './ButtonLink';
// import { t } from 'i18next';
import { withNamespaces } from 'react-i18next';

const styles = (theme) => ({
  submitWrapper: {
    margin: '0 auto',
    width: '200px',
  },
  tabContainer: {},
  title: {},
  subtext: {},
});

const ForgotPasswordTabComponent = ({ classes, handleTabChange, t, ...props }) => (
  <div className={classes.tabContainer}>
    <h1 className={classes.title}>{t('forgot_password_caps', 'Forgot Password').toLowerCase()}</h1>
    <p className={classes.subtext}>
      {t('enter_previous_email', 'Enter the email you signed up with below')}
    </p>
    <AuthenticationForm
      classes={{ submitWrapper: classes.submitWrapper }}
      submitLabel={t('send_reset_link', 'Send Reset Link')}
      {...props}
    >
      <TextField name="email" type="email" label={t('enter_email', 'Enter Email')} required />
    </AuthenticationForm>
    <div className={classes.cancelBtn}>
      <ButtonLink onClick={(e) => handleTabChange(e, 'signIn')}>{t('cancel', 'Cancel')}</ButtonLink>
    </div>
  </div>
);
ForgotPasswordTabComponent.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  handleTabChange: PropTypes.func.isRequired,
};

export const ForgotPasswordTab = withStyles(styles)(withNamespaces()(ForgotPasswordTabComponent));
